
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Trophy } from "lucide-react";
import { Achievement } from "@/utils/testDataProcessing";

interface AchievementsCardProps {
  isLoading: boolean;
  earnedAchievements: Achievement[];
}

export const AchievementsCard = ({ isLoading, earnedAchievements }: AchievementsCardProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center text-lg">
          <Trophy className="mr-2 h-5 w-5 text-orange-400" />
          Recent Achievements
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <p className="text-gray-600">Loading achievements...</p>
        ) : earnedAchievements.length > 0 ? (
          <div className="space-y-3">
            {earnedAchievements.slice(0, 3).map((achievement) => (
              <div 
                key={achievement.id}
                className="flex items-center space-x-2 p-2 rounded-lg bg-primary/5"
              >
                <Trophy className="h-4 w-4 text-orange-400" />
                <div>
                  <p className="font-medium text-sm">{achievement.title}</p>
                  <p className="text-xs text-muted-foreground">{achievement.description}</p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-600">No achievements yet</p>
        )}
      </CardContent>
    </Card>
  );
};
